import { Box, SelectBox } from "arkh";

import { OrganisationRoleType } from "./__generated__/OrgUserEditScreenQuery.graphql";
import { FormattedMessage } from "react-intl";

export function UserTypeSelect(props: {
  selected: OrganisationRoleType;
  onSelect: (value: OrganisationRoleType) => void;
}) {
  return (
    <Box style={{ flexDirection: "row" }}>
      <SelectBox
        isSelected={props.selected === "WORKSPACE_USER"}
        icon="users"
        onPress={() => props.onSelect("WORKSPACE_USER")}
      >
        <FormattedMessage
          defaultMessage="Organisation User"
          description="UserTypeSelect Organisation User"
        />
      </SelectBox>
      <SelectBox
        isSelected={props.selected === "ADMIN"}
        icon="user"
        onPress={() => props.onSelect("ADMIN")}
      >
        <FormattedMessage
          defaultMessage="Organisation Admin"
          description="UserTypeSelect Organisation Admin"
        />
      </SelectBox>
      <SelectBox
        isSelected={props.selected === "DEVELOPER"}
        icon="user"
        onPress={() => props.onSelect("DEVELOPER")}
      >
        <FormattedMessage
          defaultMessage="Developer"
          description="UserTypeSelect Developer"
        />
      </SelectBox>
    </Box>
  );
}
